import type { Reducer } from 'redux';
import { Actions } from '@/redux/user/actions';
import type { UserState, UserAction } from '@/redux/user/types';

export const initialState = {} as UserState;

export default ((state = initialState, action: UserAction) => {
  switch (action.type) {
    case Actions.SetUserData:
      return { ...state, ...action.data };

    case Actions.SetUserDataFail:
      return { ...state, error: action.error };

    case Actions.SetPrizeData:
      return { ...state, ...{ prize: action.prize } };

    case Actions.SetPrizeDataFail:
      return { ...state, error: action.error };

    case Actions.SetPointsData:
      return { ...state, ...{ points: action.points } };

    case Actions.SetPointsDataFail:
      return { ...state, error: action.error };

    case Actions.SetCountryData:
      return { ...state, ...{ country: action.country } };

    case Actions.SetCountryDataFail:
      return { ...state, error: action.error };

    case Actions.SetLanguageData:
      return { ...state, ...{ language: action.language } };

    case Actions.SetLanguageDataFail:
      return { ...state, error: action.error };

    case Actions.SetParticipantId:
      return { ...state, ...{ participant: action.id } };

    case Actions.SetParticipantIdFail:
      return { ...state, error: action.error };

    default:
      return state;
  }
}) as Reducer<UserState, UserAction>;
